import { createContext, useContext, useEffect } from "react";
import socket from "./custom-socket.jsx";

const SocketContext = createContext();

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  useEffect(() => {
    const handleSocketConnected = () => {
      console.log("socket conneced");
    };

    const handleSocketDisconnected = () => {
      console.log("handleSocketDisconnected");
    };

    socket.on("disconnect", handleSocketDisconnected);
    socket.on("connect", handleSocketConnected);

    return () => {
      socket.off("disconnect", handleSocketDisconnected);
      socket.off("connect", handleSocketConnected);
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};